import './App.scss';
import { useState } from "react";
import MusicSection from '../../components/HomePage/MusicSection/MusicSection';
import Footer from '../../layout/Footer/Footer';
import VideoSection from '../../components/HomePage/VideoSection/VideoSection';
import AboutSection from '../../components/HomePage/AboutSection/AboutSection';
import AudiobooksSection from '../../components/HomePage/AudiobooksSection/AudiobooksSection';
import { useFetchLast3 } from '../../utils/hooks/useFetch';
import { ShortsSection } from '../../components/HomePage/ShortsSection/ShortsSection';



function App() {
  const [activeTrackId, setActiveTrackId] = useState(null);
  const [AudiobooksTracks] = useFetchLast3("/JSON/audiobooks.json");
  const [musicTracks] = useFetchLast3("/JSON/musics.json");

  const allTracks = [...musicTracks, ...AudiobooksTracks];

  const handleTrackEnd = (currentTrackId) => {
    const currentIndex = allTracks.findIndex(
      (t) => t.title + t.id === currentTrackId
    );
    const nextTrack = allTracks[currentIndex + 1];
    if (nextTrack) {
      setActiveTrackId(nextTrack.title + nextTrack.id);
    } else {
      setActiveTrackId(null);
    }
  };

  return (
    <div className="App">
      <div className="presentation">
        <div className="presentation-infos">
          <div className="background-image"></div>
          <h1>Arthur <br /> Le Meur</h1>
          <h2>Compositeur de musique à l'image</h2>
        </div>
        <div className="presentation_sections_container">
          <AudiobooksSection
            activeTrackId={activeTrackId}
            setActiveTrackId={setActiveTrackId}
            trackSelection={AudiobooksTracks}
            onTrackEnd={handleTrackEnd}
          />
          <VideoSection />
        </div>
        <div className="separator"></div>
        <MusicSection
          activeTrackId={activeTrackId}
          setActiveTrackId={setActiveTrackId}
          trackSelection={musicTracks}
          onTrackEnd={handleTrackEnd}
        />
        <div className="separator"></div>
        {/* <ProjectsSection /> */}
        <ShortsSection
          activeTrackId={activeTrackId}
          setActiveTrackId={setActiveTrackId}
         />
        <AboutSection
          activeTrackId={activeTrackId}
          setActiveTrackId={setActiveTrackId}
         />
      </div>
      <Footer />
    </div>
  );
}

export default App;
